'use client';
import { Icon } from '@/components/icon';
import { Routes } from '@/constants/routes';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { IEmployeeList } from './employee-list.types';

export const EmployeeList: IEmployeeList = ({ employees }) => {
  const [errorImages, setErrorImages] = useState<number[]>([]);

  return (
    <div className="flex flex-row items-start ml-[23px] lg:ml-[50px]">
      {employees.map((employee, i) => (
        <Image
          key={employee.name + i}
          width={100}
          height={100}
          onError={() => setErrorImages((prev) => [...prev, i])}
          src={employee.avatar.url}
          alt="employee"
          className={classNames(
            'employee-list-item',
            { hidden: errorImages.includes(i) }
          )}
        />
      ))}
      <Link
        href={Routes.Careers}
        className="text-black w-[55px] lg:w-[120px] left-0 h-[55px] lg:h-[120px] bg-white rounded-[28px] lg:rounded-[60px] bottom-[5px] lg:bottom-[10px] flex flex-col items-center justify-center relative duration-200 ease-in-out cursor-pointer ml-[-28px] lg:ml-[-60px] hover:left-[-10px] hover:scale-110em"
      >
        <Icon name="joinTeam" className="text-black w-[37px] lg:w-[76px]" />
      </Link>
    </div>
  );
};
